import { Injectable, signal } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class UploadDialogService {
  // 使用signal来管理各个对话框的显示状态
  private _isUploadCreativeVisible = signal(false);
  private _isEditCreativeVisible = signal(false);
  private _isUploadMonitorVisible = signal(false);
  private _isUploadKeywordVisible = signal(false);
  private _isUploadCampaignVisible = signal(false);
  private _isUploadCampaignBudgetVisible = signal(false);
  private _isUploadCampaignNameVisible = signal(false);
  private _isUploadUnitBidVisible = signal(false);
  private _isUploadUnitTargetVisible = signal(false);
  private _isUploadKeywordBidVisible = signal(false);

  // 获取各个对话框的显示状态
  get isUploadCreativeVisible() {
    return this._isUploadCreativeVisible.asReadonly();
  }

  get isEditCreativeVisible() {
    return this._isEditCreativeVisible.asReadonly();
  }

  get isUploadMonitorVisible() {
    return this._isUploadMonitorVisible.asReadonly();
  }

  get isUploadKeywordVisible() {
    return this._isUploadKeywordVisible.asReadonly();
  }

  get isUploadCampaignVisible() {
    return this._isUploadCampaignVisible.asReadonly();
  }
  get isUploadCampaignBudgetVisible() {
    return this._isUploadCampaignBudgetVisible.asReadonly();
  }

  get isUploadCampaignNameVisible() {
    return this._isUploadCampaignNameVisible.asReadonly();
  }

  get isUploadUnitBidVisible() {
    return this._isUploadUnitBidVisible.asReadonly();
  }

  get isUploadUnitTargetVisible() {
    return this._isUploadUnitTargetVisible.asReadonly();
  }

  get isUploadKeywordBidVisible() {
    return this._isUploadKeywordBidVisible.asReadonly();
  }

  // 打开批量上传计划对话框
  openUploadCampaignDialog() {
    this._isUploadCampaignVisible.set(true);
  }

  // 关闭批量上传计划对话框
  closeUploadCampaignDialog() {
    this._isUploadCampaignVisible.set(false);
  }

  // 打开批量添加创意对话框
  openUploadCreativeDialog() {
    this._isUploadCreativeVisible.set(true);
  }

  // 关闭批量添加创意对话框
  closeUploadCreativeDialog() {
    this._isUploadCreativeVisible.set(false);
  }

  // 打开批量编辑创意对话框
  openEditCreativeDialog() {
    this._isEditCreativeVisible.set(true);
  }

  // 关闭批量编辑创意对话框
  closeEditCreativeDialog() {
    this._isEditCreativeVisible.set(false);
  }

  // 打开上传监测链接对话框
  openUploadMonitorDialog() {
    this._isUploadMonitorVisible.set(true);
  }

  // 关闭上传监测链接对话框
  closeUploadMonitorDialog() {
    this._isUploadMonitorVisible.set(false);
  }

  // 打开上传关键词对话框
  openUploadKeywordDialog() {
    this._isUploadKeywordVisible.set(true);
  }

  // 关闭上传关键词对话框
  closeUploadKeywordDialog() {
    this._isUploadKeywordVisible.set(false);
  }

  // 打开批量修改计划预算对话框
  openUploadCampaignBudgetDialog() {
    this._isUploadCampaignBudgetVisible.set(true);
  }

  // 关闭批量修改计划预算对话框
  closeUploadCampaignBudgetDialog() {
    this._isUploadCampaignBudgetVisible.set(false);
  }

  // 打开批量修改计划名称对话框
  openUploadCampaignNameDialog() {
    this._isUploadCampaignNameVisible.set(true);
  }

  // 关闭批量修改计划名称对话框
  closeUploadCampaignNameDialog() {
    this._isUploadCampaignNameVisible.set(false);
  }

  openUploadUnitBidDialog() {
    this._isUploadUnitBidVisible.set(true);
  }

  closeUploadUnitBidDialog() {
    this._isUploadUnitBidVisible.set(false);
  }

  openUploadUnitTargetDialog() {
    this._isUploadUnitTargetVisible.set(true);
  }

  closeUploadUnitTargetDialog() {
    this._isUploadUnitTargetVisible.set(false);
  }

  openUploadKeywordBidDialog() {
    this._isUploadKeywordBidVisible.set(true);
  }

  closeUploadKeywordBidDialog() {
    this._isUploadKeywordBidVisible.set(false);
  }
}
